import type { PrimaryPlacement, SecondaryPlacement, PopperPlacement } from './types';

export function convertToPopperPlacement(
  placement: PrimaryPlacement = 'top',
  secondaryPlacement?: SecondaryPlacement
): PopperPlacement {
  if (!secondaryPlacement || secondaryPlacement === 'middle') {
    return placement;
  }

  return `${placement}-${secondaryPlacement}` as PopperPlacement;
}
export function convertFromPopperPlacement(popperPlacement: PopperPlacement = 'top'): {
  placement: PrimaryPlacement;
  secondaryPlacement: SecondaryPlacement;
} {
  const [placement, secondaryPlacement = 'middle'] = popperPlacement.split('-');

  return {
    placement: placement as PrimaryPlacement,
    secondaryPlacement: secondaryPlacement as SecondaryPlacement,
  };
}
